module.exports = __webpack_public_path__ + "assets/listview.1ccee0fa.svg";